import React from "react";
import useReveal from "../hooks/useReveal";

export default function Support({ content = {} }) {
  const { ref, cls } = useReveal();
  return (
    <section className="bg-[#f6f8fb] py-24">
      <div ref={ref} className={`max-w-[1180px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center ${cls}`}>
        <div>
          <h2 className="gp-heading text-[2.3rem] sm:text-[2.7rem]">{content.support_title || "Support the way it should be"}</h2>
          <p className="text-[#5a6b80] text-[1.12rem] leading-relaxed mt-5 max-w-[480px]">
            {content.support_text || "Take your gift voucher revenue to new heights with the support of our hospitality experts."}
          </p>
          <a href="#features" className="gp-btn-outline inline-block rounded-full px-8 py-3 font-medium mt-8">
            {content.support_cta || "Learn about support"}
          </a>
        </div>
        <div className="bg-white rounded-2xl p-8 shadow-[0_15px_40px_rgba(20,30,55,0.08)] border border-gray-100">
          <div className="text-[3rem] leading-none font-serif text-[#a78bd6]">“</div>
          <p className="text-[#1c2b40] text-[1.1rem] leading-relaxed -mt-4">{content.support_quote || "We were really happy with the process of launching our online store."}</p>
          <div className="flex items-center gap-3 mt-6">
            {content.support_quote_avatar && <img src={content.support_quote_avatar} alt={content.support_quote_name} className="w-12 h-12 rounded-full object-cover" />}
            <div>
              <p className="text-[#16243b] font-semibold text-[0.95rem] leading-tight">{content.support_quote_name || ""}</p>
              <p className="text-[#8a97a8] text-[0.82rem]">{content.support_quote_role || ""}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
